export default __webpack_public_path__ + "locales/pt-BR/Webhooks.json?hash=01ebdf5a4b333ffdb41d106d88ff1ca3";